import { render, staticRenderFns } from "./ParsedDocument.vue?vue&type=template&id=2b00e219&scoped=true&lang=pug"
import script from "./ParsedDocument.vue?vue&type=script&lang=ts"
export * from "./ParsedDocument.vue?vue&type=script&lang=ts"
import style0 from "./ParsedDocument.vue?vue&type=style&index=0&id=2b00e219&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00e219",
  null
  
)

export default component.exports